module.exports = __webpack_public_path__ + "static/img/link13.134a810.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/link13.png
// module id = BtDd
// module chunks = 19